import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {faUsers, faUserTie, faIdBadge, faAward} from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/services/user.service';
import { UserSearchStateService } from 'src/app/services/userSearchState.service';

@Component({
    selector: 'app-roster',
    templateUrl: './roster.component.html',
    styleUrl: './roster.component.scss',
    standalone: false
})
export class RosterComponent implements OnInit {
  faUsers = faUsers;
  faUserTie = faUserTie;
  faIdBadge = faIdBadge;
  faAward = faAward;

  seeUnassigned: boolean = false;
  user: any;
  filterForest: boolean = false;
  filterRegion: boolean = false;
  seeGis: boolean = false;

  selectedIndex: number = 0;

  constructor(
    public userService: UserService,
    private readonly titleService: Title,
    private readonly userSearchStateService: UserSearchStateService
  ) {
    this.titleService.setTitle("BAER - Roster")
    this.setUser();
  }

  ngOnInit(): void {
    this.selectedIndex = this.userSearchStateService.tab;
  }

  onTabChange(event: any) {
    this.userSearchStateService.tab = event.index
  }

  setUser() {
    this.userService.getUserProfile().then((user) => {
      this.user = user;
      if (user.isWO) this.seeUnassigned = true;
      if (!user.woOffice) {
        if (!user.regionOffice) {
          this.filterForest = true; //forest office or simple user
        }
        else {
          this.filterRegion = true; //region office
        }
      } //else wo office - filter nothing
      if (user.isWOCO?.length) {
        this.seeGis = true;
      }
    })
  }

}
